import React from "react";
import get from "lodash/get";
import { PhotoStory } from "./photo-story";
import { VideoStory } from "./video-story";
import { TextStory } from "./text-story";

const OtherStory = data => {
  const { story, config, firstStory } = data;
  const templateType = get(config, ["theme-attributes", "other-story", "type"], "");
  switch (templateType) {
    case "photo":
      return <PhotoStory story={story} config={config} firstStory={firstStory} />;
    case "video":
      return <VideoStory story={story} config={config} firstStory={firstStory} />;
    default:
  }
  return <TextStory story={story} config={config} firstStory={firstStory} />;
};
export { OtherStory };
